import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpClient } from "@angular/common/http";
import { StripeServiceProvider } from "../../providers/stripe-service/stripe-service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CountryProvider } from "../../providers/country/country";

@IonicPage()
@Component({
  selector: 'page-payment-new-card',
  templateUrl: 'payment-new-card.html',
})
export class PaymentNewCardPage {

  public loading: boolean;
  public submitted = false;
  public billingForm: FormGroup;
  public cardForm: FormGroup;
  public intent: any;
  public card: any;
  public countries: Array<object>;
  public cardErrors: HTMLElement;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public stripeService: StripeServiceProvider,
    public formBuilder: FormBuilder,
    public events: Events,
    public countryProvider: CountryProvider
  ) {
  }

  ngOnInit() {
    this.billingForm = this.formBuilder.group({
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: [''],
      state: [''],
      country: ['', Validators.required],
      postalCode: ['', Validators.required],
    });

    this.cardForm = this.formBuilder.group({
      card_number: ['', Validators.required],
      expiry: ['', Validators.required],
      cvv: ['', Validators.required]
    });

    this.countries = this.countryProvider.getAll();
    this.cardErrors = document.getElementById('card-errors');
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.billingForm.controls;
  }



  saveCard() {
    let $this = this;
    this.loading = true;
    this.submitted = true;
    this.cardErrors.textContent = '';
    // stop here if form is invalid
    if (this.billingForm.invalid || this.cardForm.invalid) {
      $this.loading = false;
      return;
    }

    let cardNumber = this.cardForm.controls.card_number.value ? this.cardForm.controls.card_number.value : '';
    let expiry = this.cardForm.controls.expiry.value.toString().split("/");

    let cardDetails = {
      type: "card",
      card: {
        number: cardNumber.replaceAll(" ", ""),
        exp_month: expiry[0],
        exp_year: expiry[1],
        cvc: this.cardForm.controls.cvv.value
      },
      billing_details: {
        address: {
          line1: this.f.addressLine1.value,
          line2: this.f.addressLine2.value,
          city: this.f.city.value,
          state: this.f.state.value,
          country: this.f.country.value,
          postal_code: this.f.postalCode.value
        }
      }
    }

    this.stripeService.setupIntent().then((intent: any) => {
      this.stripeService.confirmCardSetup(cardDetails).then(
        function (result: any) {
          if (result.error) {
            $this.loading = false;
            $this.cardErrors.textContent = result.error.message;
          } else {
            intent.payment_method = result.id;
            intent.payment_method_options.card = result.card;
            intent.billing_details = result.billing_details;
            $this.stripeService.attachPaymentMethod(intent).then((paymentMethod) => {
              $this.events.publish('stripe:paymentMethodSaved', paymentMethod);
              $this.navCtrl.pop().then(() => {
                $this.loading = false;
              })
            }, error =>{
              $this.cardErrors.textContent = "Something went wrong please try again.";
              $this.loading = false;
            });
          }
        }, err => {
          $this.cardErrors.textContent = "Something went wrong please try again.";
          $this.loading = false;
        });
    });
    // }
  }

  validateCardDetails() {
    if (typeof (this.cardForm.controls.card_number.value) == "undefined" || this.cardForm.controls.card_number.value == null || this.cardForm.controls.card_number.value.length < 16) {
      return false;
    }
    let cardNumber = this.cardForm.controls.card_number.value ? this.cardForm.controls.card_number.value : '';
    let expiry = this.cardForm.controls.expiry.value.toString().split("/");
    let payload = {
      card_number: cardNumber.replaceAll(" ", ""),
      expiration_month: expiry[0],
      expiration_year: '20' + expiry[1],
      cvc: this.cardForm.controls.cvv.value
    };
    this.stripeService.validateCard(payload).then(
      res => {
        return true;
      }
      , err => {
        this.cardErrors.textContent = err.error;
        return false;
      });
  }

  ccExpired() {
    let date = this.cardForm.controls.expiry.value;
    let regex = /\b(0[0-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})\b/;
    if (this.cardForm.controls.expiry.value.length == 5) {
      const dateArr = date.split('/');
      const exYear = +dateArr[1] + 2000;
      const exMonth = +dateArr[0]; // JS months start with 0
      const exDay = new Date(exYear, exMonth + 1, 0).getDate();
      const dateObj = new Date(exYear, exMonth, exDay - 2); // Timezones fix.
      const dateNow = new Date();
      let cehckdate= exMonth < 10 ?  '0'+exMonth + '/'+exYear : exMonth + '/'+exYear;
      if(!regex.test(cehckdate)){
        this.cardErrors.textContent = 'Invalid card expiry date';
        return;
      }
      if (dateNow > dateObj) {
        this.cardErrors.textContent = 'Your card has been expired';
      } else {
        this.cardErrors.textContent = '';
      }
    } else {
      this.cardErrors.textContent = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment-new-card/payment-new-card.ts